import { Box, Tooltip, Typography } from "@mui/material";
import { ProjectCodeInfo } from "./InfoMessages";
import HelpIcon from "@mui/icons-material/Help";
import { useTranslation } from "react-i18next";

type ProjectCodeBoxProps = {
  projectCode: string;
};
export default function ProjectCodeBox({ projectCode }: ProjectCodeBoxProps) {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      mb={4}
      sx={{ border: 1, borderRadius: 5, width: "100%" }}
      justifyContent="center"
    >
      <Box padding={2}>
        <Typography variant="h5">
          {t("labels.projectCode")}{" "}
          <Tooltip title={<ProjectCodeInfo />}>
            <HelpIcon style={{ cursor: "default" }} />
          </Tooltip>
        </Typography>
        <Typography variant="h4" color="primary">
          {projectCode}
        </Typography>
      </Box>
    </Box>
  );
}
